/* ==========================================================================
   HOME PASSION · hareket katmani
   ========================================================================== */
(function(){
  'use strict';
  var RM = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- 1) Gorsel fade-in ---------- */
  function fadeImages(root){
    (root||document).querySelectorAll('.hp img:not([data-loaded])').forEach(function(img){
      function mark(){ img.setAttribute('data-loaded','1'); img.classList.add('hp-in'); }
      if(img.complete && img.naturalWidth>0){ mark(); }
      else { img.addEventListener('load', mark, {once:true});
             img.addEventListener('error', mark, {once:true});
             setTimeout(mark, 2500); }
    });
  }

  /* ---------- 2) Kademeli reveal ---------- */
  var io=null;
  function reveal(root){
    var els=(root||document).querySelectorAll('.hp-rv:not([data-rv]),.hp-stagger:not([data-rv])');
    if(!els.length) return;
    if(!io && 'IntersectionObserver' in window){
      io=new IntersectionObserver(function(es){
        es.forEach(function(e){ if(e.isIntersecting){ e.target.classList.add('in'); io.unobserve(e.target); } });
      },{threshold:.06, rootMargin:'0px 0px -70px 0px'});
    }
    els.forEach(function(e){
      e.setAttribute('data-rv','1');
      if(RM || !io){ e.classList.add('in'); return; }
      /* zaten ekranda veya ustunde kalanlari hemen goster */
      var r=e.getBoundingClientRect();
      if(r.top < innerHeight){ e.classList.add('in'); return; }
      io.observe(e);
    });
    /* emniyet: 4sn sonra hepsini ac */
    setTimeout(function(){
      document.querySelectorAll('.hp-rv:not(.in),.hp-stagger:not(.in)').forEach(function(e){
        var r=e.getBoundingClientRect(); if(r.top < innerHeight*1.2) e.classList.add('in');
      });
    },4000);
  }

  /* ---------- 3) Sticky header ---------- */
  function header(){
    var h=document.querySelector('.hp-hdr'); if(!h||h.dataset.init) return; h.dataset.init='1';
    var last=window.scrollY, ticking=false;
    function upd(){
      var y=window.scrollY;
      h.classList.toggle('hp-stuck', y>8);
      if(document.querySelector('.hp-mega.open')){ h.classList.remove('hp-hide'); last=y; ticking=false; return; }
      if(y>last && y>220){ h.classList.add('hp-hide'); }
      else if(y<last-4){ h.classList.remove('hp-hide'); }
      last=y; ticking=false;
    }
    addEventListener('scroll',function(){ if(!ticking){ ticking=true;
      (window.requestAnimationFrame||setTimeout)(upd,16); } },{passive:true});
    upd();
  }

  /* ---------- 4) Mega menu ---------- */
  function mega(){
    var scrim=document.querySelector('.hp-scrim');
    var items=[].slice.call(document.querySelectorAll('.hp-nav-li[data-mega]'));
    if(!items.length) return;
    var openT=null, closeT=null, current=null;
    function close(){
      if(current){ current.classList.remove('open');
        var p=current.querySelector('.hp-mega'); if(p) p.classList.remove('open'); current=null; }
      if(scrim) scrim.classList.remove('on');
    }
    function open(li){
      if(current===li) return;
      close(); current=li; li.classList.add('open');
      var p=li.querySelector('.hp-mega'); if(p) p.classList.add('open');
      if(scrim) scrim.classList.add('on');
    }
    items.forEach(function(li){
      if(li.dataset.init) return; li.dataset.init='1';
      li.addEventListener('mouseenter',function(){ clearTimeout(closeT);
        openT=setTimeout(function(){ open(li); },90); });
      li.addEventListener('mouseleave',function(){ clearTimeout(openT);
        closeT=setTimeout(close,180); });
      li.addEventListener('focusin',function(){ open(li); });
    });
    document.addEventListener('keydown',function(e){ if(e.key==='Escape') close(); });
    if(scrim) scrim.addEventListener('mouseenter',close);
  }

  /* ---------- 5) Duyuru rotatoru ---------- */
  function announce(){
    document.querySelectorAll('.hp-ann').forEach(function(bar){
      if(bar.dataset.init) return; bar.dataset.init='1';
      var msgs=[].slice.call(bar.querySelectorAll('.hp-ann-msg'));
      if(!msgs.length) return;
      msgs[0].classList.add('on');
      if(msgs.length<2){ bar.querySelectorAll('.hp-ann-arw').forEach(function(a){a.style.display='none'}); return; }
      var i=0, timer=null;
      var speed=parseInt(bar.dataset.speed||'5',10)*1000;
      function go(n){ msgs[i].classList.remove('on'); i=(n+msgs.length)%msgs.length; msgs[i].classList.add('on'); }
      function play(){ if(RM) return; clearInterval(timer); timer=setInterval(function(){ go(i+1); },speed); }
      var prev=bar.querySelector('.hp-ann-arw.prev'), next=bar.querySelector('.hp-ann-arw.next');
      if(prev) prev.addEventListener('click',function(){ go(i-1); play(); });
      if(next) next.addEventListener('click',function(){ go(i+1); play(); });
      bar.addEventListener('mouseenter',function(){ clearInterval(timer); });
      bar.addEventListener('mouseleave',play);
      play();
    });
  }

  /* ---------- 6) Mobil cekmece ---------- */
  function drawer(){
    var d=document.querySelector('.hp-drawer'), scrim=document.querySelector('.hp-scrim');
    if(!d||d.dataset.init) return; d.dataset.init='1';
    document.querySelectorAll('.hp-burger').forEach(function(b){
      b.addEventListener('click',function(){ d.classList.add('open'); if(scrim) scrim.classList.add('on');
        document.body.style.overflow='hidden'; });
    });
    function close(){ d.classList.remove('open'); if(scrim) scrim.classList.remove('on'); document.body.style.overflow=''; }
    d.querySelectorAll('[data-close]').forEach(function(b){ b.addEventListener('click',close); });
    if(scrim) scrim.addEventListener('click',close);
    document.addEventListener('keydown',function(e){ if(e.key==='Escape') close(); });
    d.querySelectorAll('[data-sub]').forEach(function(t){
      t.addEventListener('click',function(e){ e.preventDefault();
        var s=t.nextElementSibling; if(s) s.hidden=!s.hidden; });
    });
  }

  /* ---------- 7) Sepet sayaci ---------- */
  function cartSync(){
    document.addEventListener('hp:cart-added',function(){
      fetch('/cart.js').then(function(r){return r.json()}).then(function(c){
        document.querySelectorAll('[data-cart-count]').forEach(function(el){
          el.textContent=c.item_count; el.classList.add('pop');
          setTimeout(function(){ el.classList.remove('pop'); },320);
        });
      }).catch(function(){});
    });
  }

  function boot(root){ fadeImages(root); reveal(root); header(); mega(); announce(); drawer(); }
  if(document.readyState==='loading'){ document.addEventListener('DOMContentLoaded',function(){ boot(); cartSync(); }); }
  else { boot(); cartSync(); }
  addEventListener('load',function(){ boot(); });
  document.addEventListener('shopify:section:load',function(e){ boot(e.target); });
  window.hpMotionBoot=boot;
})();
